export default "__VITE_ASSET__5c4f10a7__"